import type { FC } from 'react'
import React from 'react'

import ListItem from './list-item'
import ListItemText from './list-item-text'
import type { ListItemProps, ListItemTextProps } from './types'

const StandardListItem: FC<
  Omit<ListItemProps<HTMLLIElement>, 'children'> &
    Pick<ListItemTextProps, 'primary' | 'secondary'>
> = props => {
  const { primary, secondary, ...rest } = props
  // eslint-disable-next-line no-console
  // console.log('--- render @costar/theme-ui StandardListItem -----')
  return (
    <ListItem {...rest}>
      <ListItemText primary={primary} secondary={secondary} />
    </ListItem>
  )
}

export default React.memo(StandardListItem)
